export const NYLAS_THEME_FONT = '"Montserrat", sans-serif';
export const NYLAS_THEME_BLACK = '#2b2b2b';
export const NYLAS_THEME_GOLD = '#bea06e';

export const SCHEDULER_THEME_STYLES = {
  '--nylas-primary': '#2b2b2b',
  '--nylas-error': '#cc4841',
  '--nylas-error-pressed': '#992222',
  '--nylas-wraning': '#f06c00',
  '--nylas-success': '#16a392',
  '--nylas-info': '#2b8fc2',
  '--nylas-base-0': '#ffffff',
  '--nylas-base-25': '#fcfcfd',
  '--nylas-base-50': '#f8f9fc',
  '--nylas-base-100': '#eaecf5',
  '--nylas-base-200': '#ebebeb',
  '--nylas-base-300': '#727272', // '#b3b8d8'
  '--nylas-base-400': '#717bbc',
  '--nylas-base-500': '#bea06e',
  '--nylas-base-600': '#3d3d3d',
  '--nylas-base-700': '#3d3d3d', // '#263f72'
  '--nylas-base-800': '#2b2b2b',
  '--nylas-base-900': '#101323',
  '--nylas-base-950': '#0e101b',
  '--nylas-border-radius': '0',
  '--nylas-border-radius-2x': '0',
  '--nylas-border-radius-3x': '0',
  '--nylas-font-family': '"Montserrat", sans-serif',
};

export const SCHEDULER_EDITOR_THEME_CONFIG = {
  // Font
  '--nylas-font-family': NYLAS_THEME_FONT,

  // Primary + system semantic colors
  '--nylas-primary': NYLAS_THEME_BLACK,
  '--nylas-success': NYLAS_THEME_GOLD,

  // Base levels
  '--nylas-base-400': NYLAS_THEME_BLACK,
  '--nylas-base-500': NYLAS_THEME_BLACK,
  '--nylas-base-600': NYLAS_THEME_BLACK,
  '--nylas-base-700': NYLAS_THEME_BLACK,
  '--nylas-base-800': NYLAS_THEME_BLACK,
  '--nylas-base-900': NYLAS_THEME_BLACK,
  '--nylas-base-950': NYLAS_THEME_BLACK,

  // Greyscale palette
  '--nylas-color-black': NYLAS_THEME_BLACK,
  '--nylas-color-grey-900': NYLAS_THEME_BLACK,
  '--nylas-color-grey-800': NYLAS_THEME_BLACK,
  '--nylas-color-grey-700': NYLAS_THEME_BLACK,
  '--nylas-color-grey-600': NYLAS_THEME_BLACK,
  '--nylas-color-grey-500': NYLAS_THEME_BLACK,
  '--nylas-color-grey-400': NYLAS_THEME_BLACK,
  '--nylas-color-grey-300': NYLAS_THEME_BLACK,
  '--nylas-color-grey-200': NYLAS_THEME_BLACK,
  '--nylas-color-grey-100': NYLAS_THEME_BLACK,
  '--nylas-color-grey-50': NYLAS_THEME_BLACK,
};
